export const parseTileGroups = input => {
    try {
        return JSON.parse(input);
    } catch (_) {
        console.log('Error while parsing tile groups');
        return [];
    }
};
